<template>
  <div>
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex">
              <h1>{{ cap }}</h1>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <CCard>
                  <CCardHeader>
                    <CIcon name="cil-justify-center" />
                    <strong> Informacja </strong>
                    <small></small>
                  </CCardHeader>
                  <CCardBody>
                    <CJumbotron header="Bootstrap 4" lead="">
                      <h1 class="display-3">{{cap}}</h1>
                      <p class="lead">
                       
                      </p>
                      <hr class="my-4" />
                      <p>
                      
                      </p>
                      <CButton color="primary" href="/">Powrót</CButton>
                      <!-- <CButton color="success" href="#"
                        >Do Something Else</CButton
                      > -->
                    </CJumbotron>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
export default {
  name: "Message",
  created() {
    //console.log(this.$router);
    //this.cap=this.$router.params.cap;
    this.cap = this.$router.history.current.params.cap;
  },
  data() {
    return {
      cap: "empty",
    };
  },
  methods: {
   
  },
};
</script>
